import { render } from "./PaperRecent.vue?vue&type=template&id=73cf305d&scoped=true"
import script from "./PaperRecent.vue?vue&type=script&lang=js"
export * from "./PaperRecent.vue?vue&type=script&lang=js"

import "./PaperRecent.vue?vue&type=style&index=0&id=73cf305d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73cf305d"]])

export default __exports__